import { ThemeProvider } from 'styled-components';
import * as React from 'react';
import { theme } from '@westwing/ui-kit/Theme';
import { AppProvider } from 'Components/SignupAndLoginMain/AppContext';
import MagicLinkSent from 'Components/Authentication/MagicLinkSent';
import MagicLinkForm from 'Components/Authentication/MagicLinkForm';
import ResetPasswordForm from 'Components/Authentication/ResetPasswordForm';
import ResetPasswordSent from 'Components/Authentication/ResetPasswordSent';
import PartialLoginWrapper from 'Components/Authentication/PartialLoginWrapper';
import LoginAndRegister from 'Components/Authentication/LoginAndRegister';
import AccountTransferConfirm from 'Components/Authentication/AccountTransferConfirm';
import { setCustomFeatureToggles } from 'Helpers/bellaEntry';
import SignupAndLoginMain from 'Components/SignupAndLoginMain';
import { AppShellProvider } from 'AppShell/index';
import { AppShellProps } from 'AppShell/types';

const BellaSignupOverlay = ({ ...props }: AppShellProps): JSX.Element => (
    <ThemeProvider theme={theme}>
        <AppShellProvider {...setCustomFeatureToggles(props)}>
            <AppProvider>
                <SignupAndLoginMain />
            </AppProvider>
        </AppShellProvider>
    </ThemeProvider>
);

const mainEntry = {
    ShopToClubOverlay: BellaSignupOverlay,
    MagicLinkSent,
    MagicLinkForm,
    ResetPasswordForm,
    ResetPasswordSent,
    PartialLoginWrapper,
    LoginAndRegister,
    AccountTransferConfirm,
    SignupAndLoginProvider: AppShellProvider,
};

export default mainEntry;
